import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = [ "audit--form-elements" ]

  toggle() {
    this.auditFormElementsOutlet.toggleEdit();
  }
}
